import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect, useRef } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SkipToMainContent() {
  const mainRef = useRef<HTMLElement | null>(null);

  const handleClick = () => {
    const main = document.getElementById('main-content');
    if (main) {
      main.setAttribute('tabindex', '-1');
      main.focus();
      main.addEventListener('blur', () => {
        main.removeAttribute('tabindex');
      }, { once: true });
    }
  };

  return (
    <a
      href="#main-content"
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[99999] focus:bg-forest-green focus:text-cream focus:px-5 focus:py-3 focus:rounded-lg focus:font-medium focus:text-sm focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-forest-green focus:ring-offset-2"
    >
      Skip to Main Content
    </a>
  );
}

function DarkModeSync() {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const applyDark = (matches: boolean) => {
      if (matches) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };
    applyDark(mediaQuery.matches);
    const handler = (e: MediaQueryListEvent) => applyDark(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <DarkModeSync />
      <BrowserRouter basename={__BASE_PATH__}>
        <SkipToMainContent />
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;